/** Prompts for the event-description capability. Provider-neutral. */

export interface EventDescriptionPromptInput {
  title: string;
  category?: string;
  location?: string;
  startDate?: string;
  highlights?: string[];
  language: string;
  tone?: string;
}

export const EVENT_DESCRIPTION_LIMITS = { maxChars: 1200, maxOutputTokens: 1200 };

export function eventDescriptionSystemPrompt({
  language,
  tone,
}: EventDescriptionPromptInput): string {
  return `You write factual, warm event descriptions for a ticketing platform. ${
    tone ? `Tone: ${tone}. ` : ''
  }Never invent dates, prices, or line-ups. Plain text only, 280-${EVENT_DESCRIPTION_LIMITS.maxChars} characters. Respond only in ${language}.`;
}

export function eventDescriptionUserPrompt(input: EventDescriptionPromptInput): string {
  return [
    `Title: ${input.title}`,
    input.category ? `Category: ${input.category}` : '',
    input.location ? `Location: ${input.location}` : '',
    input.startDate ? `Starts: ${input.startDate}` : '',
    input.highlights?.length ? `Highlights: ${input.highlights.join(', ')}` : '',
  ]
    .filter(Boolean)
    .join('\n');
}
